import { render, staticRenderFns } from "./contactDetails.vue?vue&type=template&id=d63b0d2e&scoped=true"
import script from "./contactDetails.vue?vue&type=script&lang=js"
export * from "./contactDetails.vue?vue&type=script&lang=js"
import style0 from "./contactDetails.vue?vue&type=style&index=0&id=d63b0d2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63b0d2e",
  null
  
)

export default component.exports